<template v-slot:top>
  <v-row
    class="pa-4"
  >
    <v-col  
      lg="2"
      class="py-0 my-0"
    >
      <v-select
        clearable
        v-model="selectProspector"
        outlined
        label="Prospector/Prospectador"
        :items="prospectores"
        @change="emitFilterTable()"
      />
    </v-col>
    <v-col
      class="py-0 my-0"
    >
      <v-select
        clearable
        v-model="selectEtapa"
        outlined
        label="Etapa"
        :items="$store.state.etapas"
        @change="emitFilterTable()"
      />
    </v-col>
    <v-col
      class="py-0 my-0"
    >
      <v-select
        clearable
        v-model="selectEstadoNegociacion"
        outlined
        label="Estado Negociación"
        :items="$store.state.estadoNegociacion"
        @change="emitFilterTable()"
      />
    </v-col>
    <v-col
      class="py-0 my-0"
    >
      <v-select
        clearable
        v-model="selectFechaEntrega"
        outlined
        label="Año de entrega"
        :items="listYear"
        @change="emitFilterTable()"
      />
    </v-col>
    <v-col
      class="py-0 my-0"
    >
      <v-text-field
        v-model="searchText"
        outlined
        label="Buscar en proyectos..."
        @keydown="emitSearch()"
      />
    </v-col>
  </v-row>
</template>

<script>
  import firebase from 'firebase'
  export default {
    props: ['proyectos', 'search'],
    data () {
      return {
        selectDistrito: null,
        selectProspector: null,
        selectEtapa: null,
        selectEstadoNegociacion: null,
        selectFechaEntrega: null,
        prospectores: [],
        searchText: this.search,
      }
    },
    computed: {
      listYear: function () {
        return ['Todos', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
      },
    },
    mounted () {
      this.getUsuarios()
    },
    methods: {
      buscar () { 
        var filtros = ['Miraflores']             
        this.filter(this.proyectos, filtros)      
      },

      filter (proyectos, filtros) {
        var cantidadFiltros = filtros.length      
        var i = 0
        var aux = []                              
        filtros.forEach(filtro => {
          i++
          proyectos.forEach(proyecto => {         
            if (proyecto.estado === filtro || proyecto.etapa === filtro || proyecto.distrito === filtro) {
              const data = {
                codigo: proyecto.codigo,
                latitud: proyecto.latitud,
                longitud: proyecto.longitud,
                nombre: proyecto.nombre,
                direccion: proyecto.direccion,
                distrito: proyecto.distrito,
                tipo: proyecto.tipo,
                categoria: proyecto.categoria,
                estado: proyecto.estado,
                numeroPisos: proyecto.numeroPisos,
                numeroDepartamentos: proyecto.numeroDepartamentos,
                etapa: proyecto.etapa,
                fechaEntrega: proyecto.fechaEntrega,
                inmobiliaria: proyecto.inmobiliaria,
                constructora: proyecto.constructora,
                proveedorActual: proyecto.proveedorActual,
                visitas: proyecto.visitas,
                foto: proyecto.foto,
                fecha_creacion: proyecto.fecha_creacion,
                fecha_edicion: proyecto.fecha_edicion,
                anio: proyecto.anio,
              }
              if (cantidadFiltros === i) {
                aux.push(data)
              }
            }
          })
        })
      },
      emitSearch () {
        this.$emit('changeSearch', this.searchText)
      },
      emitFilterTable () {
        var filtros = {
          selectDistrito: this.selectDistrito,
          selectProspector: this.selectProspector,
          selectEtapa: this.selectEtapa,
          selectEstadoNegociacion: this.selectEstadoNegociacion,
          selectFechaEntrega: this.selectFechaEntrega,
        }
        this.$emit('changeFilterTable', filtros)
      },
      getUsuarios() {
        const filteredProfiles = []

        firebase.firestore().collection('perfiles').get().then((prospectoresSnapshot) => {
          prospectoresSnapshot.forEach((prospector) => {
            const data = prospector.data()
            if (
              data &&
              data.Proyectos &&
              data.Proyectos.Prospección === true
            ) {
              filteredProfiles.push(prospector.id)
            }
          })
          /* console.log("Perfiles filtrados:", filteredProfiles) */

          firebase.firestore().collection('users').get().then((usersSnapshot) => {
            usersSnapshot.forEach((user) => {
              const userData = user.data()
              if (filteredProfiles.includes(userData.perfil)) {
                this.prospectores.push(userData.email)
                /* console.log("Usuario Permitido: ", userData.email) */
              }
            })
          })
        })
      },
    },
  }
</script>
